module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/canteencart/canteen_cart.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/canteencart/canteen_cart.png
// module id = 530
// module chunks = 0